module.exports = __webpack_public_path__ + "static/img/20004 (3).863d02e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20004 (3).webp
// module id = c9u3
// module chunks = 14